import React from 'react'
import { Box, Text, Stack } from '@/components/lib'
import utils from '@/utils/utils'

function previewText (body) {
  if (body == null || body === '') return 'Empty note'
  const t = String(body).trim()
  if (!t) return 'Empty note'
  return t
}

/**
 * Read-only “post-it” summary; parent opens ParticipantNoteEditor on click.
 */
export default function ParticipantNotePostIt ({ note, onSelect, index = 0 }) {
  const author = note?.userObject
    ? `${note.userObject.firstName || ''} ${note.userObject.lastName || ''}`.trim()
    : null
  const tilt = index % 2 === 0 ? '-0.6deg' : '0.5deg'

  return (
    <Box
      role='button'
      tabIndex={0}
      onClick={() => onSelect?.(note)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onSelect?.(note)
        }
      }}
      cursor='pointer'
      w='100%'
      maxW='280px'
      minH='112px'
      p={3}
      borderRadius='md'
      borderWidth='1px'
      borderColor='yellow.200'
      bg='yellow.50'
      _dark={{
        borderColor: 'yellow.600',
        bg: 'yellow.950'
      }}
      boxShadow='md'
      transform={`rotate(${tilt})`}
      transition='box-shadow 0.15s ease, transform 0.15s ease'
      _hover={{
        boxShadow: 'md',
        transform: `rotate(${tilt}) translateY(-2px)`
      }}
      _focusVisible={{
        outline: '2px solid',
        outlineColor: 'blue.500',
        outlineOffset: '2px'
      }}
    >
      <Stack gap={2} h='100%'>
        <Text
          fontSize='sm'
          lineHeight='short'
          lineClamp={6}
          whiteSpace='pre-wrap'
          color='fg.default'
        >
          {previewText(note?.note)}
        </Text>
        <Stack gap={0} mt='auto' pt={1} borderTopWidth='1px' borderColor='blackAlpha.100' _dark={{ borderColor: 'whiteAlpha.200' }}>
          {author && (
            <Text fontSize='xs' fontWeight='medium' color='fg.subtle' lineClamp={1}>
              {author}
            </Text>
          )}
          <Text fontSize='xs' color='fg.subtle'>
            {note?.createdAt ? utils.formatDateTime(note.createdAt) : ''}
          </Text>
        </Stack>
      </Stack>
    </Box>
  )
}
